import Vue from 'vue';

/**
 * The method used to perform an AJAX-request.
 *
 * @param {string}      requestType The request type.
 * @param {string}      url         The URL for the request.
 * @param {Object|null} data        The data to be send with the request.
 *
 * @returns {Promise} The result in a promise.
 */
const submit = (requestType, url, data = null) => new Promise((resolve, reject) => {
  let request = null;
  const options = {
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  };

  const type = requestType.toLowerCase();

  if (['get', 'delete', 'head'].includes(type)) {
    request = Vue.$http[type](url, options);
  } else {
    request = Vue.$http[type](url, data, options);
  }

  request.then((response) => {
    resolve(response.data);
  })
    .catch(({ response }) => {
      if (response) {
        reject(response.data);
      } else {
        reject();
      }
    });
});

export default {
  submit,
};
